// Minimal Buffer polyfill
import { Buffer } from 'buffer';

// Make Buffer available globally - simple approach
if (typeof window.Buffer === 'undefined') {
  window.Buffer = Buffer;
}